export default __webpack_public_path__ + "static/media/quienes-somos.62e5a0d2.jpeg";